export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Velikost'

export const SIZE_CHANGE_SHOW_TABLE = 'SIZE_CHANGE_SHOW_TABLE'
